module.exports = __webpack_public_path__ + "img/emotions.0e5f9dcf.png";